// прогрессбар для отображения загрузки

import progress from "./data/progress";

const START_FAKE_PROGRESS = 74;

const template = `
    <div class="progress-bar" >
        <div v-if="text" class="progress-bar__loading" :class="textClass">[[ text ]]</div>
        <div class="progress-bar__scale">
            <div class="progress-bar__value" :style="style()"></div>
        </div>
    </div>`;

const props = {
    progress: null,
    textClass: "",
    isFakeProgress: false,
};

const data = function () {
    return {
        leftPosition: 0,
        direction: 1,
        waitingInterval: undefined,
        type: "",
        text: "",
        currentProgress: null,
    };
};

const methods = {
    waiting() {
        this.stopWaiting();

        let direction = 1;
        this.leftPosition = 85;
        this.waitingInterval = setInterval(() => {
            this.leftPosition += 5 * direction;
            if (this.leftPosition === 90) {
                direction = -1;
            }
            if (this.leftPosition === 0) {
                direction = 1;
            }
        }, 100);
    },

    stopWaiting() {
        clearInterval(this.waitingInterval);
    },

    style() {
        if (this.type === "waiting") {
            return {
                width: "10%",
                marginLeft: `${this.leftPosition}%`,
            };
        }
        return { width: `${this.currentProgress}%` };
    },

    showProgress() {
        this.currentProgress = this.progress;
        if (this.progress >= 100) {
            this.setType("waiting");
        }
    },

    showFakeProgress() {
        if (this.currentProgress === null) {
            this.currentProgress = START_FAKE_PROGRESS;
        } else {
            this.currentProgress += 2;
        }

        if (this.currentProgress >= 100) {
            this.setType("waiting");
        } else {
            setTimeout(() => {
                this.showFakeProgress();
            }, 100);
        }
    },

    setType(type) {
        this.type = type;
        this.text = progress.TYPES[type];
        if (type === "waiting") {
            this.waiting();
        } else {
            this.stopWaiting();
        }
    },
};

const watch = {
    progress: {
        handler(val, oldVal) {
            if (oldVal === null && val === 100) {
                this.showFakeProgress();
            } else {
                this.showProgress();
            }
        },
        immediate: true,
    },
};

const mounted = function () {
    this.setType("processing");
};

export default {
    props,
    data,
    template,
    methods,
    watch,
    mounted,
};
